import None from './behavior/none';
import Shutter from './behavior/shutter';
export default {
  none: None,
  shutter: Shutter
};